const outstandingPayoffRequestsReport = {
  label: "Outstanding Payoff Requests Report",
  name: "outstandingPayoffRequestsReport",
  parameters: [
    {
      name: "db",
      label: "Database",
      type: "select",
      defaultValue: "hero",
      options: [
        { key: "hero", label: "HERO" },
        { key: "data", label: "DATA" },
      ],
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { key: "Approved", label: "Approved" },
        { key: "Assigned", label: "Assigned" },
        { key: "Cancelled", label: "Cancelled" },
        { key: "Completed", label: "Completed" },
        { key: "Draft", label: "Draft" },
        { key: "In QA", label: "In QA" },
        { key: "In Review", label: "In Review" },
        { key: "New", label: "New" },
        { key: "Paid", label: "Paid" },
        { key: "Preparing", label: "Preparing" },
        { key: "Processed in batch", label: "Processed in batch" },
        { key: "Ready to Assign", label: "Ready to Assign" },
        { key: "Refunded", label: "Refunded" },
        { key: "Rejected", label: "Rejected" },
      ],
      multiple: true,
    },
  ],
};

export default outstandingPayoffRequestsReport;
